var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 3.25H11.375C6.88769 3.25 3.25 6.88769 3.25 11.375V27.625C3.25 32.1123 6.88769 35.75 11.375 35.75H27.625C32.1123 35.75 35.75 32.1123 35.75 27.625V11.375C35.75 6.88769 32.1123 3.25 27.625 3.25Z",
    fill: "#4D2E67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.4763C26.2006 19.8287 25.9696 21.2099 25.3399 22.4234C24.7102 23.6369 23.7139 24.621 22.4927 25.2357C21.2714 25.8504 19.8875 26.0643 18.5377 25.8471C17.1878 25.6299 15.9409 24.9926 14.9741 24.0259C14.0074 23.0591 13.3701 21.8122 13.1529 20.4623C12.9357 19.1125 13.1496 17.7286 13.7643 16.5074C14.379 15.2861 15.3631 14.2898 16.5766 13.6601C17.7902 13.0305 19.1714 12.7995 20.5238 13C21.9033 13.2046 23.1804 13.8474 24.1665 14.8335C25.1526 15.8196 25.7955 17.0968 26 18.4763Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 10.5625H28.4537",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.86234336.svg";
export { ForwardRef as ReactComponent };